<section
  class="flex w-full justify-evenly gap-5 bg-gradient-to-r from-[#0b254e] to-[#154fa0] px-4 py-6 text-white"
>
  <div class="service-status-content">
    <div class="service-cta">
      <div class="total-wrapper">
        <div class="number">{{ totalServices }}</div>
        <div class="total-text">
          Total Active
          <span>Services</span>
        </div>
      </div>
      <div class="total-locations">Spanning {{ totalLocations }} locations</div>
    </div>

    <app-service-progress-bar
      [inService]="inServiceServices"
      [pending]="pendingServices"
    ></app-service-progress-bar>
  </div>

  <div class="service-pie-chart">
    <app-service-type-chart [data]="serviceTypeObject"></app-service-type-chart>
  </div>
</section>
